import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings } from "lucide-react";
import UsuariosRoles from "@/pages/UsuariosRoles";
import Facturacion from "@/pages/Facturacion";

/**
 * Módulo "Configuración" — Fase PLD puro (iter 07-26).
 *
 * Aglutina en UNA sola entrada del sidebar los 3 submódulos de configuración del tenant.
 * Cada uno vive en su TAB (regla PO: "una sola entrada por módulo").
 *
 * Tabs:
 *  - Datos de la empresa (razón social, RFC, régimen, domicilio, oficial de cumplimiento).
 *  - Usuarios y roles (invitación, permisos, sesiones).
 *  - Suscripción (plan, código de cortesía, facturación).
 *
 * Reutiliza los componentes ya construidos sin tocar su lógica.
 */
export default function ConfiguracionInmo() {
  return (
    <div className="p-6 md:p-8 space-y-6" data-testid="inmo-configuracion-page">
      <PageHeader
        title="Configuración"
        subtitle="Datos de la empresa · Usuarios y roles · Suscripción"
        icon={Settings}
      />
      <Tabs defaultValue="empresa" className="space-y-3">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="empresa" data-testid="tab-empresa">Datos de la empresa</TabsTrigger>
          <TabsTrigger value="usuarios" data-testid="tab-usuarios">Usuarios y roles</TabsTrigger>
          <TabsTrigger value="suscripcion" data-testid="tab-suscripcion">Suscripción</TabsTrigger>
        </TabsList>

        <TabsContent value="empresa">
          <div className="rounded-md border border-slate-200 bg-slate-50 p-6 space-y-2">
            <p className="text-sm text-slate-700 font-medium">Datos de la empresa</p>
            <p className="text-xs text-slate-500">
              Razón social, RFC, régimen, domicilio fiscal y datos del oficial de cumplimiento.
              Se editan desde la ficha de la entidad en <code className="mx-1 rounded bg-slate-200 px-1">/entidad</code>.
              Vista consolidada próximamente.
            </p>
          </div>
        </TabsContent>
        <TabsContent value="usuarios">
          <UsuariosRoles />
        </TabsContent>
        <TabsContent value="suscripcion">
          <Facturacion />
        </TabsContent>
      </Tabs>
    </div>
  );
}
